import { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import useStyles from '../styles';
import Button from '../../Button';
import { CLIPBOARD_FADE_TIME } from '../constants/stylesConstants';

const MessageBubble = ({ message, previousMessageWasBySameAuthor }) => {
  const classes = useStyles();
  const [clipboardClicked, setClipboardClicked] = useState(false);

  let colorClass = 'bg-gray-400';
  if (message.author === 'user') {
    colorClass = 'bg-green-500 text-white';
  } else if (message.author === 'chatgpt-error') {
    colorClass = 'bg-red-600 text-white';
  }

  // Function helps copy content from message bubble to clipboard
  const copyToClipboard = () => {
    navigator.clipboard.writeText(message.content);
    setClipboardClicked(true);
    // timeout duration should match the duration of the fade animation
    setTimeout(() => setClipboardClicked(false), CLIPBOARD_FADE_TIME * 1000);
  };

  // Try to split the message into paragraphs here
  const paragraphs = typeof message.content === 'string' ? message.content.split('\n') : null;

  return (
    <div
      className={clsx(
        previousMessageWasBySameAuthor ? 'mt-0.5' : 'mt-4',
        message.author === 'user' ? 'ml-16 text-right' : 'mr-16',
      )}
    >
      <div
        className={clsx(
          classes.parentOfHiddenUnlessHovered,
          classes.parentPosition,
          'px-6 py-4 inline-block rounded-2xl text-justify',
          classes.message,
          colorClass,
        )}
      >
        <div>
          {
            // Render each paragraph
            paragraphs
              ? paragraphs.map((paragraph, index) => (
                  <p key={paragraph} className={index === paragraphs.length - 1 ? '' : 'mb-4'}>
                    {paragraph}
                  </p>
                ))
              : message.content
          }
        </div>
        {paragraphs && message.author !== 'chatgpt-error' ? (
          <Button
            type="button"
            onClick={copyToClipboard}
            className={clsx(
              { [classes.clipboardFade]: clipboardClicked },
              classes.buttonPosition,
              classes.hiddenUnlessHovered,
            )}
            variant={Button.buttonVariants.LINK}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
              <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
            </svg>
          </Button>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

MessageBubble.propTypes = {
  message: PropTypes.shape().isRequired,
  previousMessageWasBySameAuthor: PropTypes.bool,
};

MessageBubble.defaultProps = {
  previousMessageWasBySameAuthor: false,
};

export default MessageBubble;
